import React, { memo } from 'react';

import SourceLayers from '../../source-layers/SourceLayers';

export const COUNTRY_BOUNDARIES_SOURCE_ID = 'country-boundaries-transparent';
export const COUNTRY_BOUNDARIES_LAYER_ID = 'country-boundaries-transparent';

const CountryBoundariesTransparentLayerInternal = () => (
  <SourceLayers
    source={{
      id: COUNTRY_BOUNDARIES_SOURCE_ID,
      data: {
        type: 'vector',
        url: 'mapbox://mapbox.country-boundaries-v1',
      },
    }}
    layers={{
      id: COUNTRY_BOUNDARIES_LAYER_ID,
      type: 'fill',
      source: COUNTRY_BOUNDARIES_SOURCE_ID,
      'source-layer': 'country_boundaries',
      paint: {
        'fill-color': [
          'coalesce',
          ['feature-state', 'fillColor'],
          'transparent',
        ],
        'fill-color-transition': {
          duration: 0,
          delay: 0,
        },
        'fill-antialias': true,
        'fill-translate': [0, 0],
      },
    }}
  />
);

CountryBoundariesTransparentLayerInternal.displayName =
  'CountryBoundariesControl';

export const CountryBoundariesTransparentLayer = memo(
  CountryBoundariesTransparentLayerInternal,
);
